import { useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

interface SkuLookupRequest {
  DealNumber: string;
  DiscountDealId: number;
  IsXcmVendor?: boolean;
  PageNumber: number;
  PageSize: number;
  ProductGroup?: string;
  ProductId?: number;
  VendorProgramId: string;
  Vpn?: string;
}

export interface SkuLookupResponse {
  result: {
    crCcode: string;
    productGroup: string;
    sku: string;
    vpn: string;
  }[];
  totalCount: number;
}

interface XcmVendorSkuLookupRequest {
  DealNumber: string;
  DiscountDealId: number;
  IsXcmVendor: boolean;
  PageNumber: number;
  PageSize: number;
  ProductId?: number;
  VendorProgramId: number;
  Version: string;
  Vpn: string;
}

export interface XcmVendorSkuLookupResponse {
  result: {
    crCcode: boolean;
    isXcmVendor: boolean;
    offeringId: number;
    offeringType: number;
    productId: number;
    sku: string;
  }[];
  totalCount: number;
}

export function useSkuLookUp(params: SkuLookupRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<SkuLookupResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiDeals/SkuLookup',
    params,
    {
      enabled: !params.IsXcmVendor,
    },
    undefined,
    { host: buildVars.VP_API_BASE }
  );
}

export function useXcmVendorSkuLookup(params: XcmVendorSkuLookupRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<XcmVendorSkuLookupResponse>(
    '/system.webapi.gds/api/v1/GdsCoreApiDeals/GetXCMVendorSkuLookup',
    params,
    {
      enabled: params.IsXcmVendor,
    },
    {
      'IM-CountryCode': 'US',
    },
    { host: buildVars.VP_API_BASE }
  );
}
